import $ from "jquery";
import ProductListFilters from "components/productlist_filters";
import PubSub from "pubsub-js";
import Offcanvas from "components/offcanvas";
import LazyScroll from "components/lazyscroll";
import DisplayModusToggle from "components/productlist_displaymodus";
import VariationController from "components/product_detail/variation_controller";
import SalesBoxCartButtonController from "components/sales_box/sales_box_cart_button_controller";
import AdsQuantityChange from "components/product_detail/ads_quantity_change";
import BrandTeaser from "teaser/brand_teaser";
import NewsTeaser from "teaser/news_teaser";
import TripleProductTeaser from "teaser/triple_product_teaser";
import LeadTeaser from "teaser/lead_teaser";
import ProductListGallery from "utils/productlist_gallery";
import SmoothScroll from "utils/smoothscroll";
import ElementToggler from "utils/element_toggler";
import NumberPlusMinusButtons from "utils/form_elements/number_plus_minus_buttons";
import ScrollToTopHelper from "utils/scroll_to_top_helper";
import ProductListingKeepPositionHelper from "utils/product_listing_keep_position_helper";
import ProductListPaging from "components/product_list/product_list_paging";
import TabController from "components/tab_controller";
import ContentSearchFilterController from "components/product_list/content_search_filter";
import ProductListFilterController from "components/product_list/product_list_filter_controls";
import ProductCompareUtils from "components/product_comparison";
import "bootstrap";
import {ViewItemListListener} from "../tracking/google/ga4/view_item_list_listener";
import {SelectItemTracker} from "../tracking/google/ga4/select_item_tracker";

export default function Product() {
  PubSub.subscribe("core.attach", this.attach.bind(this));
  PubSub.subscribe("res", this.resxs.bind(this));
  this.productListingKeepPositionHelper = new ProductListingKeepPositionHelper();
  this.productListingKeepPositionHelper.init();
  this.productListingKeepPositionHelper.initClearHandler();
  this.offcanvas = new Offcanvas();
  this.filters = new ProductListFilters();
  this.brandTeaser = new BrandTeaser();
  this.newsTeaser = new NewsTeaser();
  this.tripleProductTeaser = new TripleProductTeaser();
  this.leadTeaser = new LeadTeaser();
  this.leadTeaser.init();
  this.productListGallery = new ProductListGallery();
  this.productListPaging = new ProductListPaging();
  this.productListPaging.init();
  new SmoothScroll();
  new ElementToggler().init();
  new DisplayModusToggle();
  new VariationController().init();
  new SalesBoxCartButtonController().init();
  new AdsQuantityChange().init();
  new TabController().initForProductList();
  new ContentSearchFilterController().init();
  new ProductListFilterController().init();
  this.productCompareUtils = new ProductCompareUtils();
  this.productCompareUtils.initListing();
  $(document).ajaxComplete(function () {
    new NumberPlusMinusButtons().init();
  });
  new ScrollToTopHelper().init();
  const $productList = $(".product-list-grid");
  ViewItemListListener($productList);
  SelectItemTracker($productList);
}

Product.prototype = {
  attach: function (msg, element) {
    if ($(element).has(".product-list-part")) {
      new LazyScroll(".product-list", ".product-grid-item");
    }

    //Form Toggle
    var toggleBtn = $(".page-product-list [data-toggle=offcanvas]");
    var _this = this;

    toggleBtn.off("click").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.offcanvas.toggle();
    });

    $("input:radio").on('click', function () {
      $('label[for="' + $(this).attr("id") + '"]').toggleClass("list-active");
    });

    this.pagination = $(".list-pager", element)
        .pagination({container: $(".product-list-part")})
        .data("Pagination");

    //Close
    $(".product-filter-controls .close-btn", element)
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          _this.offcanvas.hide();
        });

    $(".wiki-teaser-links>li").popover();

    $("ul.item-selling-points > li > span.truncatable-content").each(
        function () {
          var element = this;
          if (
              element.offsetHeight < element.scrollHeight ||
              element.offsetWidth < element.scrollWidth
          ) {
            $(element).closest("li").addClass("truncated");
          }
        }
    );

    $(".category-list").click(function (e) {
      e.preventDefault();
      let categoryUrl = new URL($(this).attr("href"));

      for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
        if (key.startsWith("filter")) {
          categoryUrl.searchParams.append(key, value);
        }
      }

      window.location = categoryUrl;
    });
  },
  resxs: function (message, on_off) {
    if ((message === "res.xs" || message === "res.sm") && on_off) {
      this.isxs = on_off;
      this.offcanvas.switchIt(on_off);
    } else if (message === "res.md" && on_off) {
      this.isxs = false;
      this.offcanvas.switchIt(false);
    }
    //Re-Setup Swipes
    if (on_off) {
      this.productListGallery.responsive(message, on_off);
      this.brandTeaser.responsive(message, on_off);
      this.newsTeaser.responsive(message, on_off);
      this.tripleProductTeaser.responsive(message, on_off);
      this.leadTeaser.responsive(message, on_off);
      this.productCompareUtils.responsive(message, on_off);
    }
  },
  enableRange: function (enable) {
    $("#from_price, #to_price").prop("disabled", !enable);
  },
};

